module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path.indexOf('_detail') === -1 && _vm.$route.path.indexOf('_editor') === -1) ? _c('div', [_c('el-row', {
    staticClass: "content-bottom-padded",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.addElement
    }
  }, [_vm._v("表单元素添加")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择表单元素"
    },
    on: {
      "change": _vm.searchData
    },
    model: {
      value: (_vm.params.form_element),
      callback: function($$v) {
        _vm.$set(_vm.params, "form_element", $$v)
      },
      expression: "params.form_element"
    }
  }, _vm._l((_vm.formElement), function(item, key) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "标题"
    },
    model: {
      value: (_vm.params.field_title),
      callback: function($$v) {
        _vm.$set(_vm.params, "field_title", $$v)
      },
      expression: "params.field_title"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.searchData
    },
    slot: "append"
  })], 1)], 1)], 1), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, _vm._l((_vm.tabList), function(item, index) {
    return _c('el-tab-pane', {
      key: index,
      attrs: {
        "label": item.name,
        "name": item.activeName
      }
    }, [_c('el-table', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: (_vm.loading),
        expression: "loading"
      }],
      attrs: {
        "data": _vm.ItemsList,
        "height": _vm.wheight - 280
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "id",
        "label": "ID",
        "width": "50"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "field_title",
        "label": "标题",
        "width": "250"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "field_name",
        "label": "唯一标示(纯字母)",
        "width": "200"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "form_element",
        "label": "元素类型",
        "width": "100"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "元素选择项"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return _vm._l((scope.row.options), function(item, index) {
            return _c('span', {
              key: index
            }, [_vm._v(" " + _vm._s(item.value))])
          })
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "操作",
        "width": "100"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('router-link', {
            staticClass: "iconfont icon-edit1",
            attrs: {
              "to": {
                path: _vm.matchHidePage('editor'),
                query: {
                  id: scope.row.id
                }
              }
            }
          }), _vm._v(" "), _c('i', {
            staticClass: "iconfont icon-search-plus",
            on: {
              "click": function($event) {
                return _vm.preview(scope.$index, scope.row)
              }
            }
          }), _vm._v(" "), (scope.row.status == 1) ? _c('i', {
            staticClass: "mark iconfont icon-trash-alt1",
            on: {
              "click": function($event) {
                return _vm.deleteAction(scope.$index, scope.row)
              }
            }
          }) : _vm._e()]
        }
      }], null, true)
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "content-center content-top-padded"
    }, [_c('el-pagination', {
      attrs: {
        "background": "",
        "layout": "total, sizes, prev, pager, next",
        "current-page": _vm.params.page,
        "page-sizes": [10, 20, 50],
        "total": _vm.total_count,
        "page-size": _vm.params.pageSize
      },
      on: {
        "current-change": _vm.handleCurrentChange,
        "size-change": _vm.handleSizeChange,
        "update:currentPage": function($event) {
          return _vm.$set(_vm.params, "page", $event)
        },
        "update:current-page": function($event) {
          return _vm.$set(_vm.params, "page", $event)
        }
      }
    })], 1)], 1)
  }), 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "dataInfo",
    staticClass: "demo-ruleForm",
    attrs: {
      "label-width": "200px",
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.dataInfo.field_title
    }
  }, [(_vm.dataInfo.form_element == 'text') ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "text预览"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.dataInfo.form_element == 'textarea') ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "textarea预览"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.dataInfo.form_element == 'number') ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-input-number', {
    attrs: {
      "type": "textarea",
      "placeholder": "55.55"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.dataInfo.form_element == 'image') ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "",
      "show-file-list": false
    }
  }, [(_vm.imageUrl) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.imageUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.dataInfo.form_element == 'radio') ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-radio-group', _vm._l((_vm.dataInfo.options), function(item, index) {
    return _c('el-radio', {
      key: index,
      attrs: {
        "label": 3
      }
    }, [_vm._v(_vm._s(item.value))])
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.dataInfo.form_element == 'checkbox') ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-checkbox-group', _vm._l((_vm.dataInfo.options), function(item, index) {
    return _c('el-checkbox', {
      key: index,
      attrs: {
        "label": "item.value"
      }
    }, [_vm._v(_vm._s(item.value))])
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.dataInfo.form_element == 'select') ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    }
  }, _vm._l((_vm.dataInfo.options), function(item, key) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.value,
        "value": item.value
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.dataInfo.form_element == 'date') ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.dataInfo.form_element == 'time') ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-time-picker', {
    attrs: {
      "arrow-control": "",
      "picker-options": {
        selectableRange: '18:30:00 - 20:30:00'
      },
      "placeholder": "任意时间点"
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.dataInfo.form_element == 'area') ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-cascader', {
    attrs: {
      "options": _vm.options,
      "props": {
        expandTrigger: 'hover'
      }
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1) : _vm._e()], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4f52fc02", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f52fc02"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/selfservice/formsettinglist.vue
// module id = 2704
// module chunks = 0